import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Menu from './SelectionMenu';
import * as userDataActions from '../../actions/userDataActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as appHelper from '../../helpers/appHelper';
import * as dataHelper from '../../helpers/dataHelper';
import * as localStorage from '../../localStorage/localStorage';

class LocalePicker extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showTitle: appHelper.isDefined(this.props.showTitle) ? this.props.showTitle : true,
            userData: this.props.userData,
            contentData: this.props.contentData,
            currentSelection:{},
            menuData:[],
            onMenuSelect: PropTypes.func,
            idKey:"id",
            labelKey:"label",
        };
        this.setLocaleMenuData = this.setLocaleMenuData.bind(this);
        this.onMenuSelect = this.onMenuSelect.bind(this);
    }

    componentDidMount() {
        this.setLocaleMenuData();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            let currentLang = appHelper.getArrayObjectByKey(localStorage.languages,"language_code",nextProps.userData.lang);
            let currentSelection = {
                constant: currentLang.language_code,
                id: currentLang.language_id,
                label:  this.state.showTitle ? `${currentLang.language_name} - <span class="title-case">${currentLang.language_code}</span>` : `<span class="title-case">${currentLang.language_code}<span/>`
            };
            this.setState({
                userData: nextProps.userData,
                currentSelection: Object.assign({},currentSelection)
            });
        }

    }

    componentDidUpdate() {

    }


    setLocaleMenuData(){
        let menuData = [];
        let languages = localStorage.languages;

        for(let i = 0; i < languages.length; i++){
            let lang = languages[i];
            let menuItem = {
                constant: lang.language_code,
                id: lang.language_id,
                label: `${lang.language_name} - <span class="title-case">${lang.language_code}</span>`
            };
            menuData = dataHelper.immutablePush(menuData, menuItem);
        }

        let currentLang = appHelper.getArrayObjectByKey(localStorage.languages,"language_code",this.state.userData.lang);
        let currentSelection = {
            constant: currentLang.language_code,
            id: currentLang.language_id,
            label:  this.state.showTitle ? `${currentLang.language_name} - <span class="title-case">${currentLang.language_code}</span>` : `<span class="title-case">${currentLang.language_code}<span/>`
        };

        this.setState({
            menuData: Object.assign([],menuData),
            currentSelection: Object.assign({},currentSelection)

        });

    }

    onMenuSelect(data){
        this.props.actions.updateExperienceLocale(data.constant).then((userData) => {
            this.props.actions.setSuspendData(userData);

        }).catch(error => {

        });
    }

    render() {
        return (
            this.state.menuData.length > 0
                ?
                <div>
                    <Menu currentSelection={this.state.currentSelection} menuData={this.state.menuData} classExtention="locale-picker"
                          idKey={this.state.idKey} labelKey={this.state.labelKey} onMenuSelect={this.onMenuSelect}/>
                </div>
                :
                <p>No Locale</p>
        );
    }
}

LocalePicker.propTypes = {
    showTitle: PropTypes.bool,
    userData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

LocalePicker.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        contentData: state.contentData,
        userData: state.userData,

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocalePicker);



/** WEBPACK FOOTER **
 ** ./src/components/form/LocalePicker.js
 **/